import { render, staticRenderFns } from "./NewTransactionServiceRenderFundForm.vue?vue&type=template&id=04dfc96a&scoped=true"
import script from "./NewTransactionServiceRenderFundForm.vue?vue&type=script&lang=js"
export * from "./NewTransactionServiceRenderFundForm.vue?vue&type=script&lang=js"
import style0 from "./NewTransactionServiceRenderFundForm.vue?vue&type=style&index=0&id=04dfc96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dfc96a",
  null
  
)

export default component.exports